import { retrieveMediaMapFromIds } from '~/lib/media';
export const useMediaLoader = () => {
  const { $db } = useNuxtApp();

  const mediaIds = ref<string[]>([]);
  const addIds = (pIds: string[] | Ref<string[]>) => {
    const ids = toValue(pIds);
    mediaIds.value = [...mediaIds.value, ...ids];
  };
  const addId = (pId: string | Ref<string>) => {
    const id = toValue(pId);
    mediaIds.value.push(id);
  };
  const retrieveAll = async (): Promise<Map<string, MediaSchema>> => {
    const media = await retrieveMediaMapFromIds($db, mediaIds.value);
    return media;
  };
  const releaseIds = () => {
    mediaIds.value = [];
  };
  return {
    mediaIds,
    releaseIds,
    addIds,
    addId,
    retrieveAll,
  };
};
